import { IMember, INewUser } from "@wingspanhq/users/dist/lib/interfaces";

import { selectorAddressDefaultValues } from "../FormPartialAddress";

import { FormData } from "./types";

export const selectorDefaultValues = (
  user: INewUser,
  member: IMember
): FormData => {
  return {
    dob: user.profile.dob,
    firstName: user.profile.firstName || "",
    foreignTaxId: (member.profile as any).foreignTaxId || "",
    isPersonalAddressTheSame: !member.profile.homeAddress?.country,
    isUSPerson: false,
    // Todo: reach out backend team to add foreignTaxId property to member profile
    lastName: user.profile.lastName || "",
    personalAddress: selectorAddressDefaultValues(member.profile.homeAddress),
    preferredName: user.profile.preferredName || "",
    ssn: ""
  };
};
